module.exports = __webpack_public_path__ + "assets/img/footer_logo_3.bef9bac1.png";